import React from "react";
import "./MyInterestsPart.css";
import { getSkillsImageUrl } from "../../utils/cloudinary";

// Cloudinary URLs for skills and interests images
const all_tesla_models = getSkillsImageUrl('all_tesla_models');
const finance_and_stocks = getSkillsImageUrl('finance_and_stocks');
const programming_wallpaper = getSkillsImageUrl('programming_wallpaper');
const meat_wallpaper = getSkillsImageUrl('meat_wallpaper');
const lexus_lfa = getSkillsImageUrl('lexus_lfa');
const apache = getSkillsImageUrl('apache');
const f22_raptor = getSkillsImageUrl('f22_raptor');
const airbus_a320 = getSkillsImageUrl('airbus_a320');
const huracan_sterrato = getSkillsImageUrl('huracan_sterrato');
const rimac = getSkillsImageUrl('rimac');

const MyInterestsPart: React.FC = () => {

    return (
        <div className="my-interests-part-container">
            <div className="my-interests-part-content-container">
                <p className="my-interests-part-title">MY INTERESTS</p>
                <div className="my-interest-part-interests-box">
                    <div className="my-interests-box-column-1">
                        <div className="my-interest-box-column-1-row-1">
                            <div className="my-interest-box-column-1-row-1-interest-container-1">
                                <img
                                    src={finance_and_stocks}
                                    alt="finance and stocks"
                                    className="my-interest-box-column-1-row-1-interest-container-1-image"
                                />
                            </div>
                            <div className="my-interest-box-column-1-row-1-interest-container-2">
                                <p className="my-interest-box-column-1-row-1-interest-container-2-category">
                                    Finance
                                </p>
                                <p className="my-interest-box-column-1-row-1-interest-container-1-title">
                                    stocks and options
                                </p>
                                <p className="my-interest-box-column-1-row-1-interest-container-1-description">
                                    I am interested in and have been trading
                                    stocks and stock options for some years. I
                                    am mostly interested in long-term investment
                                    in growth-stocks in the technology sector,
                                    as this is where I have the best
                                    understanding.
                                </p>
                            </div>
                        </div>
                        <div className="my-interest-box-column-1-row-2">
                            <div className="my-interest-box-column-1-row-2-interest-container-1">
                                <div className="my-interest-box-column-1-row-2-interest-container-1-outer-images-container">
                                    <div className="my-interest-box-column-1-row-2-interest-container-1-images-container-1">
                                        <img
                                            className="my-interest-box-column-1-row-2-interest-container-1-images-container-image"
                                            src={apache}
                                            alt=""
                                        />
                                        <img
                                            className="my-interest-box-column-1-row-2-interest-container-1-images-container-image"
                                            src={lexus_lfa}
                                            alt=""
                                        />
                                        <img
                                            className="my-interest-box-column-1-row-2-interest-container-1-images-container-image"
                                            src={airbus_a320}
                                            alt=""
                                        />
                                    </div>
                                    <div className="my-interest-box-column-1-row-2-interest-container-1-images-container-2">
                                        <img
                                            className="my-interest-box-column-1-row-2-interest-container-1-images-container-image"
                                            src={huracan_sterrato}
                                            alt=""
                                        />
                                        <img
                                            className="my-interest-box-column-1-row-2-interest-container-1-images-container-image"
                                            src={f22_raptor}
                                            alt=""
                                        />
                                        <img
                                            className="my-interest-box-column-1-row-2-interest-container-1-images-container-image"
                                            src={rimac}
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <p className="my-interest-box-column-1-row-2-interest-container-1-images-container-category">
                                    Transport
                                </p>
                                <p className="my-interest-box-column-1-row-2-interest-container-1-images-container-title">
                                    VEHICLES AND AIRCRAFT
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="my-interests-box-column-2">
                        <div className="my-interest-box-column-2-interest-container-1">
                            <p className="my-interest-box-column-2-interest-container-1-category">
                                Technology
                            </p>
                            <p className="my-interest-box-column-2-interest-container-1-title">
                                Electric vehicles
                            </p>
                            <div className="my-interest-box-column-2-interest-container-1-image-container">
                                <img
                                    className="my-interest-box-column-2-interest-container-1-image"
                                    src={all_tesla_models}
                                    alt=""
                                />
                            </div>
                            <p className="my-interest-box-column-2-interest-container-1-description">
                                I follow the development of new electric
                                vehicles (EVs) and EV technology closely and
                                sincerely believe they are the only way forward
                                for the car industry
                            </p>
                        </div>
                        <div className="my-interest-box-column-2-interest-container-2">
                            <div className="my-interest-box-column-2-interest-container-2-image-container">
                                <img
                                    className="my-interest-box-column-2-interest-container-2-image"
                                    src={programming_wallpaper}
                                    alt=""
                                />
                            </div>
                            <div className="my-interest-box-column-2-interest-container-2-right-container">
                                <p className="my-interest-box-column-2-interest-container-2-right-container-category">
                                    Technology
                                </p>
                                <p className="my-interest-box-column-2-interest-container-2-right-container-title">
                                    software
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="my-interests-box-column-3">
                        <div className="my-interest-box-column-3-interest-container-1">
                            <p className="my-interest-box-column-3-interest-container-1-category">
                                Health
                            </p>
                            <p className="my-interest-box-column-3-interest-container-1-title">
                                Nutrition
                            </p>
                            <div className="my-interest-box-column-3-interest-container-1-image-container">
                                <img
                                    className="my-interest-box-column-3-interest-container-1-image"
                                    src={meat_wallpaper}
                                    alt=""
                                />
                            </div>
                            <p className="my-interest-box-column-3-interest-container-1-description">
                                I've recently become interested in nutrition,
                                which it turns out is incredibly complex! There
                                are way too many myths about it and a podcaster
                                I listen to has a saying: 'Everything you've
                                learned is wrong, and the opposite is true.'
                                This seems to be surprisingly accurate.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyInterestsPart;
